import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Select from 'components/select';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { orderPayload, urlParams } from 'pages/provisioning/aws/account-vending/store';
import { updateContributorADGroup } from 'pages/provisioning/aws/account-vending/store/selector';
import useDebounce from 'pages/cloud-onboarding/hooks/use-debounce';
import { isADGroupError, isDuplicate } from 'pages/provisioning/aws/account-vending/utils';

const ADGroupContributor = ({ indexVal, validationData, indexList, updateEmptyList }) => {
    const [order] = useRecoilState(orderPayload);
    const [options, setOptions] = React.useState([]);
    const updateGroup = useSetRecoilState(updateContributorADGroup);
    const params = useRecoilValue(urlParams);

    const adGroupsApi = useMutation((payload) => axios.get(endPoints.aws.lookups.awsPrivilegedAdGroup(payload)));

    const debouncedInputValue = useDebounce(order?.privilegedADGroupList?.[indexVal]?.contributorInputValue, 500);

    const handleOnSelectChange = (selectedValue, index, key) => {
        updateGroup({ selectedValue, index, key });
    };
    const inputChangeHandler = (selectedValue, index, key) => {
        updateGroup({ selectedValue, index, key });
    };

    React.useEffect(() => {
        if (adGroupsApi?.isSuccess && adGroupsApi.data?.data && debouncedInputValue !== '') {
            const adList = adGroupsApi.data?.data?.map((adGroup) => ({
                label: adGroup?.displayName,
                value: adGroup?.displayName,
            }));
            setOptions(adList);
        }
    }, [adGroupsApi?.isSuccess]);

    useEffect(() => {
        if (debouncedInputValue) {
            adGroupsApi.mutate(debouncedInputValue);
        } else {
            setOptions([]);
        }
    }, [debouncedInputValue]);

    const isEmpty = (indexValue) => {
        if (indexList?.length) return indexList.includes(indexValue);
        return false;
    };

    return (
        <>
            <Box display="flex" alignItems="center" gap={1}>
                <Select
                    key="adGroupContributor"
                    label="Privileged Active Directory Group"
                    value={order?.privilegedADGroupList?.[indexVal]?.contributorValue || null}
                    options={options}
                    handleOnSelect={(value) => handleOnSelectChange(value, indexVal, 'inputSelect')}
                    isLoading={adGroupsApi.isLoading}
                    noOptionsText="Type to search"
                    autoComplete
                    includeInputInList
                    // filterSelectedOptions
                    fullWidth
                    onInputChange={(event, newInputValue) => {
                        updateEmptyList(indexVal);
                        inputChangeHandler(newInputValue, indexVal, 'inputChange');
                    }}
                    disabled={params?.journeyId && indexVal === 0}
                    customValidate={
                        isDuplicate(
                            order?.privilegedADGroupList?.map((item) => item?.contributorValue),
                            order?.privilegedADGroupList?.[indexVal]?.contributorValue
                        ) ||
                        isADGroupError(validationData, order?.privilegedADGroupList?.[indexVal]?.contributorValue) ||
                        isEmpty(indexVal)
                            ? 'validate'
                            : ''
                    }
                />
            </Box>
        </>
    );
};

ADGroupContributor.propTypes = {
    indexVal: PropTypes.number,
    validationData: PropTypes.array,
    indexList: PropTypes.array,
    updateEmptyList: PropTypes.func,
};

ADGroupContributor.defaultProps = {
    indexVal: 0,
    validationData: [],
    indexList: [],
    updateEmptyList: () => {},
};

export default React.memo(ADGroupContributor);
